import Icon from '../components/Icon.vue'

Icon.register({"align-right":{"width":448,"height":512,"paths":[{"d":"M160 84V44C160 35.2 167.2 28 176 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H176C167.2 100 160 92.8 160 84zM16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172V212C0 220.8 7.2 228 16 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM176 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H176C167.2 284 160 291.2 160 300V340C160 348.8 167.2 356 176 356z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-right.js
// module id = 2xM6
// module chunks = 0